import styles from './styles.module.scss';
import { ReactNode } from 'react';
import clsx from 'clsx';

type InputProps = {
  children: ReactNode;
  className?: string;
};

export const ContentBox = ({ children, className }: InputProps) => {
  return <div className={clsx(styles.root, className)}>{children}</div>;
};
